import React from 'react'
import { Collapse } from 'antd'
import { useTranslation } from 'react-i18next'

import { Empty } from 'src/components/atoms'

import { HierarchyProps } from '../tree-side-options'
import HierarchyFlowsApprovals from '../hierarchy-flows-approvals'
import HierarchyFlowsChained from '../hierarchy-flows-chained'
import HierarchyFlowsClosings from '../hierarchy-flows-closings'
import HierarchyFlowsConferences from '../hierarchy-flows-conferences'

export default function HierarchyFlows(props: HierarchyProps) {
  const { t } = useTranslation()

  if (!props.treesSelected?.id) {
    return <Empty />
  }

  return (
    <>
      <Collapse accordion>
        <Collapse.Panel
          header={t('web.tree.flows.approvals.title')}
          key="approval"
          showArrow
        >
          <HierarchyFlowsApprovals
            policies={props.policies}
            policyTree={props.policyTree}
            resetPoliciesTrees={props.resetPoliciesTrees}
            treesSelected={props.treesSelected}
          />
        </Collapse.Panel>
        <Collapse.Panel
          header={t('web.tree.flows.conferences.title')}
          key="conference"
          showArrow
        >
          <HierarchyFlowsConferences
            policies={props.policies}
            policyTree={props.policyTree}
            resetPoliciesTrees={props.resetPoliciesTrees}
            treesSelected={props.treesSelected}
          />
        </Collapse.Panel>
        <Collapse.Panel
          header={t('web.tree.flows.closings.title')}
          key="closing"
          showArrow
        >
          <HierarchyFlowsClosings 
            treesSelected={props.treesSelected} 
            policyTree={props.policyTree} 
            resetPoliciesTrees={props.resetPoliciesTrees} 
          />
        </Collapse.Panel>
      </Collapse>
      <HierarchyFlowsChained treesSelected={props.treesSelected} setTreeSelected={props.setTreeSelected}  />
    </>
  )
}
